<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="form"
          :inline="true"
          label-position="right"
          label-width="100px"
          :model="queryForm"
          @submit.native.prevent
        >
          <el-form-item label="交易单号">
            <el-input
              v-model="queryForm.psp_order_id"
              placeholder=""
              style="width: 187px"
              clearable
            />
          </el-form-item>
          <el-form-item label="出货状态">
            <el-select
              v-model="queryForm.orderOutStatus"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in outStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="景区名称">
            <el-select
              v-model="queryForm.storeId"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in storeList"
                :key="item.storeId"
                :label="item.storeName"
                :value="item.storeId"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="时间范围">
            <el-select
              v-model="queryForm.timeRange"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in timeRangeList"
                :key="index.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <!--          <el-form-item label="时间段">-->
          <!--            <el-date-picker-->
          <!--                v-model="queryForm.dateRange"-->
          <!--                align="right"-->
          <!--                :default-time="['00:00:00', '23:59:59']"-->
          <!--                end-placeholder="结束日期"-->
          <!--                start-placeholder="开始日期"-->
          <!--                type="datetimerange"-->
          <!--            />-->
          <!--          </el-form-item>-->

          <el-form-item>
            <el-button
              icon="el-icon-search"
              native-type="submit"
              size="medium"
              type="primary"
              @click="handleQuery"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="tableCard">
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        row-key="transaction_id"
        border
        stripe
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column
          align="center"
          label="序号"
          width="80"
          prop="parentIndex"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.isIndex">{{ scope.row.parentIndex }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="交易单号"
          prop="psp_order_id"
          height="500"
        />
        <el-table-column
          align="center"
          label="支付时间"
          prop="finish_time"
          show-overflow-tooltip
          width="180"
        >
          <template #default="{ row }">
            <p>{{ row.finish_time }}</p>
          </template>
        </el-table-column>

        <el-table-column align="center" label="支付方式" show-overflow-tooltip>
          <template #default="{ row }">
            <p>{{ row.psp_name | PSPNameFilter }}</p>
            <p>
              <el-tag
                v-if="
                  row.transaction_status == 'ING' &&
                  diffTimestamp(serverTimeNow, row.add_time) > OUT_TIMEOUT
                "
                :type="'info'"
              >
                {{ "CANCEL" | payStatusFilter }}
              </el-tag>
              <el-tag v-else :type="row.transaction_status | statusFilter">
                {{ row.transaction_status | payStatusFilter }}
              </el-tag>
            </p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="出货状态" show-overflow-toolti>
          <template #default="{ row }">
            <el-tag
              v-if="row.order_out_status"
              :type="row.order_out_status | statusFilter"
            >
              {{ row.order_out_status | outStatusFilter }}
            </el-tag>
            <el-tag
              v-else-if="
                (row.order_pay_status == 'SUCCESS' ||
                  row.order_pay_status == 'DOUBLEPAY') &&
                diffTimestamp(serverTimeNow, row.add_time) > OUT_TIMEOUT &&
                row.order_out_status == ''
              "
              :type="'OVERTIME' | statusFilter"
            >
              {{ "OVERTIME" | outStatusFilter }}
            </el-tag>
            <el-tag
              v-else-if="
                (row.order_pay_status == 'SUCCESS' ||
                  row.order_pay_status == 'DOUBLEPAY') &&
                diffTimestamp(serverTimeNow, row.add_time) < OUT_TIMEOUT &&
                row.order_out_status == ''
              "
              :type="'ING' | statusFilter"
            >
              {{ "ING" | outStatusFilter }}
            </el-tag>
            <el-tag
              v-else-if="row.order_out_status == '出货超时'"
              :type="'WAZ' | statusFilter"
            >
              {{ "出货超时" | outStatusFilter }}
            </el-tag>
            <el-tag
              v-else-if="row.order_out_status == '通讯超时'"
              :type="'WAZ' | statusFilter"
            >
              {{ "通讯超时" | outStatusFilter }}
            </el-tag>
            <el-tag
              v-else-if="row.order_out_status == '出货异常'"
              :type="'WAZ' | statusFilter"
            >
              {{ "出货异常" | outStatusFilter }}
            </el-tag>
            <el-tag
              v-else-if="row.order_out_status == '吐货成功'"
              :type="'吐货成功' | statusFilter"
            >
              {{ "吐货成功" | outStatusFilter }}
            </el-tag>
            <el-tag
              v-else-if="row.order_out_status == '等待吐货'"
              :type="'等待吐货' | statusFilter"
            >
              {{ "等待吐货" | outStatusFilter }}
            </el-tag>
            <el-tag
              v-else-if="row.order_out_status == '还未吐货'"
              :type="'还未吐货' | statusFilter"
            >
              {{ "还未吐货" | outStatusFilter }}
            </el-tag>
            <el-tag
              v-else-if="row.order_out_status == '出货失败'"
              :type="'出货失败' | statusFilter"
            >
              {{ "出货失败" | outStatusFilter }}
            </el-tag>
            <el-tag v-else :type="'WAZ' | statusFilter">
              {{ row.order_out_status | outStatusFilter }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="退款类型" show-overflow-tooltip>
          <template #default="{ row }">
            <el-tag
              v-if="row.refund_status"
              size="small"
              :type="row.refund_status | statusFilter"
            >
              {{ row.refund_status | refundStatusFilter }}
            </el-tag>
            <el-tag v-else>未退款</el-tag>
            <!--            <p>-->
            <!--              <span>退款备注：-&#45;&#45;</span>-->
            <!--            </p>-->
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="订单/实付金额"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            <span>{{
              row.genesis === "777" ? (row.amount / 100).toFixed(2) : row.amount
            }}</span>
            <span>/</span>
            <span>{{
              row.genesis === "777"
                ? (row.actual_collection / 100).toFixed(2)
                : row.actual_collection
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="已退金额" show-overflow-tooltip>
          <template #default="{ row }">
            <span>{{
              row.genesis === "777"
                ? row.refund_amount === 0
                  ? 0
                  : (row.refund_amount / 100).toFixed(2)
                : row.refund_status && row.transaction_status === "SUCCESS"
                ? row.amount
                : row.refund_amount
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="退款时间"
          prop="refund_time"
          show-overflow-tooltip
        />
        <el-table-column
          align="center"
          label="是否重复支付状态"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            <el-tag v-if="row.order_pay_status == 'DOUBLEPAY'" :type="'danger'">
              {{ "是" }}
            </el-tag>
            <el-tag v-else :type="'info'">
              {{ "否" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="设备/商品名称">
          <template #default="{ row }">
            <span>{{ row.device_name }}</span>
            <span>/</span>
            <span>{{ row.goods_name }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="货道" width="80">
          <template #default="{ row }">
            <span>{{ Number(row.channel) + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="数据来源"
          prop="genesis"
          show-overflow-tooltip
          width="80"
        />
        <el-table-column align="center" label="操作">
          <template #default="{ row }">
            <el-button
              v-if="
                (!row.refund_status && row.transaction_status === 'SUCCESS') ||
                (row.genesis === '777' && row.amount !== row.refund_amount)
              "
              size="medium"
              type="primary"
              @click="handleManualRefund(row)"
            >
              <span>退款</span>
            </el-button>
            <el-tag
              v-if="
                (row.genesis !== '777' && row.refund_status) ||
                (row.genesis === '777' && row.amount === row.refund_amount)
              "
              size="small"
              type="info"
            >
              已退款
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
    <el-dialog
      title="是否确认退款？"
      :visible.sync="dialogVisible"
      width="20%"
      center
    >
      <p>
        交易单号：<el-tag>{{ dialogForm.psp_order_id }}</el-tag>
      </p>
      <p class="pay_time">
        支付时间：<el-tag>{{ dialogForm.finish_time }} </el-tag>
      </p>
      <p class="pay_time">
        商品名称：<el-tag>{{ dialogForm.goods_name || "-" }} </el-tag>
      </p>
      <p class="pay_time">
        退款金额：
        <el-tag v-if="dialogForm.params && dialogForm.params.genesis !== '777'">
          <!--          {{ dialogForm.params && dialogForm.params.genesis === '777'? ((dialogForm.amount /100).toFixed(2)) : dialogForm.amount }}-->
          {{ dialogForm.amount }}
        </el-tag>
        <el-input
          v-else
          type="text"
          v-model="dialogForm.refundMoney"
          :placeholder="
            '可退' +
            ((dialogForm.amount - dialogForm.refund_amount) / 100).toFixed(2) +
            '元'
          "
          class="refundMoney"
        ></el-input>
      </p>
      <p class="pay_time">
        退款原因(必填)：
        <el-checkbox-group v-model="reasonList" class="reasonsBox">
          <el-checkbox
            v-for="res in realReasons"
            :label="res.value"
            :key="res.value"
            >{{ res.label }}</el-checkbox
          >
        </el-checkbox-group>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="fakeManuanlRefund"
          >确认退款</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import store from "@/store";
import { tableList, storeList } from "../mock.js";
import { getList, fakeManuanlRefund, getStoreList } from "@/api/order";
import { Message } from "element-ui";

export default {
  data() {
    return {
      pro: process.env.VUE_APP_STATISTICS_BASIC_API,

      queryForm: {
        page: 1,
        pageSize: 10,
        psp_order_id: "", // 交易单号
        orderOutStatus: "", //出货状态
        storeId: "", // 景区名称
        timeRange: "0", // 时间范围(默认是查询2小时内的数据)
        dateRange: "", // 时间段
      }, // 搜索条件表单
      activeNames: "0",
      height: this.$baseTableHeight(), // 表格的高度
      dialogVisible: false, // 模态框是否展示
      dialogForm: {}, // 模态框展示的数据
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0, // 总数据条数

      tableData: [],
      // tableData: this.getTreeData(),
      // listLoading: true, // 列表数据是否正在加载中
      serverTimeNow: "", // 服务器当前的时间，用来计算表格中支付是否已经完成（通过请求来获取的）
      OUT_TIMEOUT: 120000, // 出货超时时间为2分钟，即120000毫秒

      // 高级搜索

      outStatusList: [
        // 出货状态
        { value: "SUCCESS", label: "出货成功(5.0/777)" },
        { value: "FAIL", label: "出货失败(5.0)" },
        // { value: 'CANCEL', label: '出货取消(5.0)' },
        { value: "ING", label: "等待出货(5.0/777)" },
        { value: "OVERTIME", label: "结果未知(5.0)" },
        { value: "出货超时", label: "出货超时(5.0)" },
        { value: "通讯超时", label: "通讯超时(5.0)" },
        { value: "出货异常", label: "出货异常(5.0)" },
        { value: "6", label: "还未吐货(2.0&3.0)" },
        { value: "9", label: "出货失败(2.0&3.0)" },
        { value: "8", label: "出货超时(2.0&3.0)" },
        { value: "0", label: "等待吐货(2.0&3.0)" },
        { value: "1", label: "吐货成功(2.0&3.0)" },
      ],
      timeRangeList: [
        // 时间范围
        { value: "0", label: "近2小时" },
        { value: "1", label: "近一天" },
        { value: "2", label: "近三天" },
        { value: "3", label: "近一周" },
        { value: "4", label: "近一月" },
        // { value: '5', label: '近两个月' },
      ],
      // storeList: storeList, // 景区列表
      storeList: [], // 景区列表
      // refundDesc: '', // 退款备注
      reasonList: [], // 退款原因列表
      reasons: [
        // 781/782/783 等设备使用的后端原始原因码
        { label: "商品损坏", value: "1" },
        { label: "未出货", value: "2" },
        { label: "重复支付", value: "3" },
        { label: "景区账号退款失败", value: "4" },
        { label: "出货与下单商品不符", value: "5" },
        { label: "外壳损坏", value: "6" },
        { label: "纪念章/大牌/集章册瑕疵", value: "7" },
        { label: "未出货", value: "8" },
        { label: "重复支付", value: "9" },
        { label: "大牌机器卡死", value: "13" },
        { label: "大牌打印瑕疵", value: "14" },
        { label: "777不出货", value: "15" },
        { label: "777漏墨", value: "16" },
        //780设备退款原因
        { label: "激光雕刻失败", value: "18" },
        { label: "激光雕刻错位", value: "19" },
        { label: "商品损坏", value: "20" },
        { label: "出错货", value: "10" }, // 最后的选项
        { label: "7天无理由", value: "11" }, // 最后的选项
        { label: "测试", value: "12" }, // 最后的选项
      ],
      realReasons: [], // 当前种类的退款原因
    };
  },
  created() {
    this.fetchData();
    this.getStoreList(); // 获取景区列表

    // this.showStatus = store.getters.showStatus
    // this.getTreeData();
  },
  mounted() {},
  filters: {
    statusFilter(status) {
      // 用来给tag增加不同颜色
      const statusMap = {
        SUCCESS: "success",
        CANCEL: "info",
        DOUBLEPAY: "danger",
        FAIL: "danger",
        ING: "default",
        MANUALREFUND: "info",
        AUTOREFUND: "info",
        OVERTIME: "warning",
        出货超时: "warning",
        通讯超时: "warning",
        出货异常: "danger",
        还未吐货: "warning",
        出货失败: "danger",
        等待吐货: "default",
        吐货成功: "success",
        WAZ: "danger", // 兜底的异常状态
      };
      return statusMap[status];
    },
    outStatusFilter(status) {
      const outMap = {
        SUCCESS: "出货成功",
        FAIL: "出货失败",
        CANCEL: "出货取消", // 不应该存在的状态，但由于测试的时候没有按照业务逻辑，所以出现的异常状态。
        OVERTIME: "结果未知",
        ING: "等待出货",
        通讯超时: "通讯超时",
        出货异常: "出货异常",
        还未吐货: "还未吐货",
        出货失败: "出货失败",
        出货超时: "出货超时",
        等待吐货: "等待吐货",
        吐货成功: "吐货成功",
      };

      return outMap[status];
    },
    payStatusFilter(status) {
      const outMap = {
        SUCCESS: "支付成功",
        CANCEL: "取消",
        ING: "等待支付",
      };
      return outMap[status];
    },
    refundStatusFilter(status) {
      const outMap = {
        AUTOREFUND: "自动退款",
        MANUALREFUND: "手工退款",
        REFUNDALL: "全部退款",
        REFUNDPART: "部分退款",
        "": "未退款", // 待后续使用
      };
      return outMap[status];
    },
    PSPNameFilter(status) {
      const outMap = {
        ali: "支付宝",
        wechat: "微信",
        icbc: "工行",
        union: "银联",
      };
      return outMap[status];
    },
  },

  methods: {
    // 获取景区列表
    getStoreList() {
      const _this = this;
      getStoreList()
        .then((res) => {
          const data = res.body;
          // 把数据整理一下
          _this.storeList = data.map((val) => {
            return {
              storeId: val.storeId + "-" + val.genesis,
              storeName: `${val.storeName}(${val.genesis})`,
            };
          });

          // _this.storeList = data; // 全部的景区数据
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getTreeData(oldData) {
      // 把数据整理成树状结构
      let newArr = oldData.map((val, index, arr) => {
        const tempOrder = [...val.transaction_info]; // 把数据复制一份，等会用来切割
        tempOrder.shift(); // 把数组里面的第一项去掉

        const publicData = {
          order_id: val.order_id, // 退款要用的数据
          device_code: val.device_code, // 退款要用的数据
          deviceId: val.device_id, // 退款要的设备id
          deviceName: val.device_name, // 退款设备名称

          order_out_status: val.order_out_status, // 出货状态
          order_pay_status: val.order_pay_status, // 支付状态
          add_time: val.add_time_str, // 时间
          amount: val.amount, // 订单金额
          actual_collection: val.actual_collection, // 实付金额
          refund_amount: val.refund_amount, // 已经退款金额
          device_name: val.device_name, // 设备名称
          goods_name: val.goods_name, // 商品名称
          channel: val.channel, // 货道
          genesis: val.genesis, // 数据来源
          device_type: val.device_type, // 设备类型用来区分退款原因的
        };

        const childData = tempOrder.map((inner) => {
          // 这是重复的订单数据，包含了公共数据+自己私有数据
          return {
            ...publicData,
            ...inner,
          };
        });

        return {
          ...publicData,
          isIndex: true,
          parentIndex: index + 1,
          transaction_id: val.transaction_info[0].transaction_id, // 唯一标志
          psp_order_id: val.transaction_info[0].psp_order_id, // 交易单号
          finish_time: val.transaction_info[0].finish_time_str, // 支付时间
          psp_name: val.transaction_info[0].psp_name, // 支付方式
          transaction_status: val.transaction_info[0].transaction_status, // 是否支付成功
          refund_status: val.transaction_info[0].refund_status, // 退款状态
          refund_time: val.transaction_info[0].refund_time_str || "-", // 退款时间
          children: childData,
        };
      });
      console.log(newArr);
      return newArr;
    },
    // 每页条目数改变事件
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData();
    },
    // 页改变事件
    handleCurrentChange(val) {
      this.queryForm.page = val;
      this.fetchData();
    },
    // form数据清洗
    formDataHelper() {
      let adujstQueryForm = Object.assign({}, this.queryForm);

      if (adujstQueryForm.dateRange) {
        // 时间转时间戳
        adujstQueryForm.startTime = Date.parse(adujstQueryForm.dateRange[0]);
        adujstQueryForm.endTime = Date.parse(adujstQueryForm.dateRange[1]);
      }

      return adujstQueryForm;
    },
    handleQuery() {
      // 查询
      this.queryForm.page = 1;
      // 查询（3:近一周，4:近一月，这两个情况下，必须要写订单号，否则报错）
      const { timeRange } = this.queryForm;
      console.log(timeRange);
      if (timeRange === "3" || timeRange === "4") {
        const range = timeRange === "3" ? "周" : "月";
        if (this.queryForm.psp_order_id === "") {
          Message.error(`需订单号才可查询近一${range}数据`);
          return;
        }
      }
      this.fetchData();
    },
    async fetchData() {
      // 拉取数据
      // let adujstQueryForm = this.formDataHelper(); // 携带了模糊查询要改变的数据结构
      // 这里发请求
      let params = {
        // ...adujstQueryForm,// 交易单号、开始日期、结束日期
        psp_order_id: this.queryForm.psp_order_id, // 交易单号
        timeRange: this.queryForm.timeRange, // 时间范围
        order_out_status: this.queryForm.orderOutStatus, // 出货状态
        storeId: this.queryForm.storeId, // 景区名称// 把版本号携带过去
        page: this.queryForm.page,
        pageSize: this.queryForm.pageSize,
      };
      console.log(params);
      await getList(params)
        .then((res) => {
          if (res && res.code === "2000") {
            this.tableData = this.getTreeData(res.body.data); // 这是请求到的列表
            this.page = res.body.page; // 当前页码
            this.total = res.body.totalRecords; // 总共数量
            this.serverTimeNow = res.body.timeNow; // 服务器时间
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 小工具：计算两个可读时间的时间戳差
    diffTimestamp(now, previous) {
      if (now.indexOf("-")) {
        now = now.split("-").join("/");
      }
      if (previous.indexOf("-")) {
        previous = previous.split("-").join("/");
      }
      return Date.parse(now) - Date.parse(previous);
    },
    // 点击退款按钮，弹出弹窗
    handleManualRefund(row, index) {
      console.log(row, row.device_type);
      let commonList = ["10", "11", "12"];
      let differentList;
      // 根据不同的数据来源区分不同的退款原因
      if (row.genesis === "2.0" || row.genesis === "3.0") {
        // 纪念章
        differentList = ["6", "7", "8", "9", ...commonList];
      }
      if (row.genesis === "5.0" || row.genesis === "5.0大牌") {
        console.log(row.device_type, row.genesis);
        if (row.device_type === 1 || row.device_type === 4 ) {
          // 纪念章(or 779)
          differentList = ["6", "7", "8", "9", ...commonList];
        } else if (row.device_type === 2) {
          // 776
          differentList = ["8", ...commonList];
        } else if (row.device_type === 3) {
          // 大牌
          differentList = ["13", "14", ...commonList];
        } else if (row.device_type === 5) {
          // 780设备
          differentList = ["6", "8", "20", "18", "19", ...commonList];
        } else if (row.device_type === 6 || row.device_type === 8) {
          // 781 / 783
          differentList = ["2", "3", "4", "5", "6", "10", "11", "12", "20"];
        } else if (row.device_type === 7) {
          // 782 报纸机
          differentList = ["1", "2", "3", "5", "11", "12"];
        }
      }
      if (row.genesis === "777") {
        // 777
        differentList = ["15", "16", ...commonList];
      }
      console.log(differentList);
      // 把reasons进行过滤，找到真正能选择的退款原因
      this.realReasons = this.reasons.filter((val) =>
        differentList.includes(val.value)
      );
      console.log(this.realReasons);

      // 打开弹窗
      this.reasonList = []; // 打开弹窗的时候，把退款原因清空
      this.dialogForm = {
        psp_order_id: row.psp_order_id, // 交易单号
        finish_time: row.finish_time, // 支付时间
        goods_name: row.goods_name, // 商品名称
        amount: row.amount, // 退款金额 (in cents)
        refund_amount: row.refund_amount, // 已经退款金额 (in cents)
        params: {
          // 退款要传递给接口的数据
          orderId: row.order_id,
          transactionId: row.transaction_id,
          deviceCode: row.device_code,
          amount: String(row.amount.toFixed(2)),
          genesis: row.genesis, // 系统版本
          pspOrderId: row.psp_order_id,
          deviceId: row.deviceId,
          deviceName: row.deviceName,
          deviceType: row.device_type, // 设备类型
          channel: row.channel, // 货道
        },
      };
      console.log(this.dialogForm);
      this.dialogVisible = true;
    },
    // 请求手工退款
    fakeManuanlRefund() {
      this.$confirm("确认退款？")
        .then(() => {
          if (this.dialogForm.params.genesis === "777") {
            if (!this.dialogForm.refundMoney) {
              this.$message({
                message: "退款金额不能为空",
                type: "error",
              });
              return;
            }
            const reg = /^\d+(\.\d+)?$/;

            if (!reg.test(this.dialogForm.refundMoney)) {
              this.$message({
                message: "只能输入数字",
                type: "error",
              });
              return;
            }
            console.log(Math.round(Number(this.dialogForm.refundMoney) * 100), this.dialogForm.amount - this.dialogForm.refund_amount,'+++');
            if (
              Math.round(Number(this.dialogForm.refundMoney) * 100) >
              this.dialogForm.amount - this.dialogForm.refund_amount
            ) {
              this.$message({
                message: "退款金额不能大于可退金额",
                type: "error",
              });
              return;
            }
          }
          if (this.dialogForm.params.genesis === "777") {
            this.dialogForm.params.amount = String(
              Math.round(this.dialogForm.refundMoney * 100).toFixed(0)
            );
          }

          if (this.reasonList.length === 0) {
            this.$message({
              message: "请选择退款原因",
              type: "error",
            });
            return;
          }
          if (this.dialogForm.params.genesis !== "777") {
            // 手动退款金额，需要向上取整
            this.dialogForm.params.amount = String(
              Number(this.dialogForm.params.amount).toFixed(2)
            );
          }
          console.log(this.dialogForm.params, "this.reasonList");
          fakeManuanlRefund({
            ...this.dialogForm.params,
            reasonList:
              this.reasonList.length > 0 ? this.reasonList : undefined, // 退款的原因列表
          })
            .then(() => {
              this.$message({
                message: "已退款成功",
                type: "success",
              });
              this.dialogVisible = false; // 关闭模态框

              // this.listLoading = false; // 关闭列表
              this.fetchData(); // 重新请求数据
            })
            .catch((err) => {
              this.$message({
                message: "退款异常，请人工核实",
                type: "error",
              });
              this.dialogVisible = false;
              // this.listLoading = false
            });
        })
        .catch((err) => {
          console.log(err);
        });
      // this.listLoading = true
    },
  },
};
</script>
<style lang="scss" scoped>
.refundMoney {
  width: 50%;
}

.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.tableCard {
  margin-top: 20px;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.pay_time {
  margin-top: 20px;
}

.reasonsBox {
  //color: red;
}

.el-pagination {
  text-align: center;
  margin-top: 10px;
}

.expandTable {
  th {
    height: 40px;
    font-size: 14px;
    font-weight: 400;
    line-height: 23px;
    color: #606266;
    text-align: center;
  }
  tr th:first-child {
    visibility: hidden;
  }
  tr th:nth-child(2) {
    visibility: hidden;
  }
  tr th:nth-child(3) {
    border-left: 1px solid #ebeef5;
  }
  tr td:first-child {
    visibility: hidden;
  }
  tr td:nth-child(2) {
    visibility: hidden;
  }
  tr td:nth-child(3) {
    border-left: 1px solid #ebeef5;
  }
  td {
    height: 40px;
    font-size: 14px;
    font-weight: 400;
    color: #606266;
    text-align: center;
    // line-height: 23px;
  }
}
</style>
<style lang="scss">
</style>